import React, { useState } from 'react'
import Card from 'components/Card'
import featureCodes from 'constants/featureCodes'
import isEmpty from 'lodash/isEmpty'
import propTypes from 'global/propTypes'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import Text from 'components/Text'
import useFeatureAccessControlEnabled from 'hooks/useFeatureAccessControlEnabled'
import { useTranslation } from 'react-i18next'

import './shipOverview.less'
import DeviceDetailsDrawer from './DeviceDetailsDrawer'
import MoreInfoContent from './MoreInfoContent'
import ShipOverviewTable from './ShipOverviewTable'

const ShipOverview = ({
  isLoading,
  isUnlockingDeviceId,
  onClearUnlockDeviceError,
  onUnlockDevice,
  shipOverviewData,
  unlockDeviceError,
}) => {
  const { t } = useTranslation()
  const isDeviceDetailsEnabled = useFeatureAccessControlEnabled(
    featureCodes.SHOW_DEVICE_DETAILS
  )
  const [isDeviceDetailsDrawerOpen, setIsDeviceDetailsDrawerOpen] =
    useState(false)

  const openDeviceDetailsDrawer = () => setIsDeviceDetailsDrawerOpen(true)
  const closeDeviceDetailsDrawer = () => setIsDeviceDetailsDrawerOpen(false)

  const devices = shipOverviewData?.devices || []

  return (
    <Card
      className="ship-overview__container"
      moreInfoContent={<MoreInfoContent />}
      moreInfoTitle={t('portCall.shipOverview.moreInfo.title')}
      title={t('portCall.shipOverview.shipOverview')}
      headerActionButton={
        isDeviceDetailsEnabled
          ? {
              disabled: isLoading,
              label: t('portCall.shipOverview.deviceDetails'),
              onClick: openDeviceDetailsDrawer,
            }
          : null
      }
    >
      {isLoading ? (
        <div className="ship-overview__loading-spin">
          <Spin />
        </div>
      ) : isEmpty(shipOverviewData) || isEmpty(shipOverviewData.bays) ? (
        <div className="ship-overview__no-moves-planned-container">
          <Text>{t('portCall.shipOverview.waitingForBaplie')}</Text>
        </div>
      ) : (
        <ShipOverviewTable
          accommodationAfterBay={shipOverviewData.accommodationAfterBay}
          bays={shipOverviewData.bays}
          devices={devices}
          engineAfterBay={shipOverviewData.engineAfterBay}
          showDeviceColumn={isDeviceDetailsEnabled}
        />
      )}

      {isDeviceDetailsEnabled && (
        <DeviceDetailsDrawer
          devices={devices}
          error={unlockDeviceError}
          isOpen={isDeviceDetailsDrawerOpen}
          isUnlockingDeviceId={isUnlockingDeviceId}
          onClearError={onClearUnlockDeviceError}
          onClose={closeDeviceDetailsDrawer}
          onUnlock={onUnlockDevice}
        />
      )}
    </Card>
  )
}

ShipOverview.defaultProps = {
  isUnlockingDeviceId: null,
  shipOverviewData: null,
  unlockDeviceError: null,
}

ShipOverview.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isUnlockingDeviceId: PropTypes.string,
  onClearUnlockDeviceError: PropTypes.func.isRequired,
  onUnlockDevice: PropTypes.func.isRequired,
  shipOverviewData: propTypes.shipOverview,
  unlockDeviceError: PropTypes.string,
}

export default ShipOverview
